import React from 'react';
import { Route,Routes } from 'react-router-dom';

import Page403 from './routes/403'
import Page404 from './routes/404'
import Page500 from './routes/500'
import './styles.scss';


const Page = ({ /* match */ }) => (
  <div className="page-err-container">
    <Routes>
    <Route path="/403" element={<Page403></Page403>}/>
    <Route path="/404" element={<Page404></Page404>}/>
    <Route path="/500" element={<Page500></Page500>}/>
    {/* <Route path={`${match.url}/403`} element={<Page403></Page403>}/>
    <Route path={`${match.url}/404`} element={<Page404></Page404>}/>
    <Route path={`${match.url}/500`} element={<Page500></Page500>}/> */}
    </Routes>
  </div>
)

export default Page;
